module.exports = __webpack_public_path__ + "static/media/40_A.439039f8.png";